import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import useStaticPopperActionPopup from "../../../../hooks/useStaticPopperActionPopup";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import ConfirmDeletePopup from "../../message/confirmDeletePopup/ConfirmDeletePopup";
import classes from "./ToolDotsActions.module.css";

const ToolDotsActions = ({ tool, onEdit, onDelete }) => {
    const { texts } = useSelector(state => state.translate);
    const [showConfirm, setShowConfirm] = useState(false);
    const { showMenu, menuStyles, buttonRef, menuRef, toggleMenu, closeMenu } = useStaticPopperActionPopup();

    const handleToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu();
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        closeMenu();
        onEdit?.(tool);
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        closeMenu();
        setShowConfirm(true);
    };

    const handleConfirmDelete = () => {
        setShowConfirm(false);
        onDelete?.(tool);
    };

    return (
        <div className={classes.ToolDotsActions} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
            <button
                type="button"
                className={classes.DotsBtn}
                ref={buttonRef}
                onClick={handleToggle}
                aria-label={texts.toolActionsMenu}
            >
                ⋮
            </button>
            {showMenu && createPortal(
                <div className={classes.Menu} ref={menuRef} style={menuStyles}>
                    {onEdit &&
                        <button type="button" className={classes.MenuItem} onClick={handleEdit}>
                            <Icon name={iconsList.edit} size="18px" color="#7622FF" />
                            <span className={classes.MenuItemText}>{texts.editToolMenu}</span>
                        </button>
                    }
                    {onDelete &&
                        <button type="button" className={classes.MenuItem} onClick={handleDeleteClick}>
                            <Icon name={iconsList.delete} size="18px" color="#7622FF" />
                            <span className={classes.MenuItemText}>{texts.deleteToolMenu}</span>
                        </button>
                    }
                </div>
                , document.body)}
            {showConfirm &&
                <ConfirmDeletePopup
                    onClose={() => setShowConfirm(false)}
                    onClick={handleConfirmDelete}
                    text={texts.confirmDeleteToolText}
                    confirmText={texts.confirmDeleteToolTitle}
                />
            }
        </div>
    );
};

export default ToolDotsActions;
